import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=1ed061f2&scoped=true&"
import script from "./Archived.vue?vue&type=script&lang=js&"
export * from "./Archived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed061f2",
  null
  
)

export default component.exports